/* eslint-disable no-redeclare */
import { z } from 'zod';

export const KindOfMedicarePlanDto = z.enum([
  'medicare_advantage',
  'medicare_supplement_medigap',
  'not_sure',
]);

export type KindOfMedicarePlanDto = z.infer<typeof KindOfMedicarePlanDto>;
